import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudComputeServices = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'compute_services/',
    params: params,
    defaultTenant: true,
    method: 'get'
  })
}
